<template lang="pug">
#home.container-fluid
  .desktop
    #desktop-landing.row
      .col-12.px-4.group
        .title-text
          h1.title DEFENSORES DE LA
            br 
            | DEMOCRACIA
          p.mt-3.mb-1 El nacimiento de la libertad de expresión<br>
            span.bold y la muerte que viene con ella.
          p.small(v-if="isLoading") Cargando ...
          b-spinner.align-middle(type="grow", v-if="isLoading")

        Clip
        //video.col-12.p-0(autoplay loop muted="muted")
          source.source(src="/video/DFvideo5_short.mp4" type="video/mp4")
        //video.col-12.p-0(autoplay loop muted="muted")
          source.source(src="/video/DFvideo5_short.webm" type="video/webm")
        img.video.col-12.p-0(src="/video/DFvideo5_short.gif")
      .chartgroup.col-12.px-0
        Scatter.scatter.step.col-12(v-if="allJournalists.length > 0")
        #scroll-bottom
      //svg(version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1920 1920" style="enable-background:new 0 0 1920 1920;" xml:space="preserve")
        defs
          clipPath#clip
            circle( cx="100" cy="100" r="40")
            circle( cx="60" cy="60" r="40")
      .footer.col-12
        //.row
          p.col-7.my-1.pl-4 Apoyado por:
        .row.sponsors.d-flex.justify-content-between
          .col-7.d-flex.align-items-center
            .row
              .col-3.d-flex.justify-content-center.align-items-center
                img.brown(src="/img/brown_logo_black.png")
              .col-4.d-flex.justify-content-center.align-items-center
                img.ddld(src="/img/ddld_logo.png")
              .col-5.d-flex.justify-content-center.align-items-center
                img.boell(src="/img/logo-boell-mx-es-city.svg")
              //.col-3.d-flex.justify-content-center.align-items-center
                img(src="/img/ford_foundation.png")
          a.col-4.d-flex.justify-content-center.align-items-center.p-0(href="https://anchor.fm/voces-silenciadas", target="_blank")
            img(class="img-fluid" src="/img/banner_vs_ddld.png")

  .mobile.mobile-home
    .row
      .mobile-landing
        img.mask.img-fluid(src="/img/Mobile-Mask.png", alt="mask for video")
        //img.img-fluid(src="/img/Mobile-Mask.png" alt="mask for video")
        .intro.col-12.p-3
          h1.title DEFENSORES<br>DE LA DEMOCRACIA
          p.mt-3 El nacimiento de la libertad de expresión<br>
            span.bold y la muerte que viene con ella.
          b-spinner.align-middle(type="grow", v-if="isLoading")
        .mobile-video-group
          //video.col-12.p-0(autoplay loop muted="muted" webkit-playsinline="true" playsinline="1")
            source.source(src="/video/DFvideo5_short.mp4" type="video/mp4")
          //video.col-12.p-0(autoplay loop muted="muted" webkit-playsinline="true" playsinline="1")
            source.source(src="/video/DFvideo5_short.webm" type="video/webm")
          img.video.col-12.p-0(src="/video/DFvideo5_short.gif")

          i.fas.fa-chevron-down(v-if="!isLoading", @click="scrollToChart()")
          p.loading.text-center(v-if="isLoading") Cargando...
      Scatter.scatter.step.col-12(v-if="allJournalists.length > 0")
</template>

<script>
import Scatter from "@/components/Scatter.vue";
import Clip from "@/assets/Clip.vue";
import * as d3 from "d3";
import ScrollReveal from "scrollreveal";
import scrollama from "scrollama";

export default {
  name: "home",
  components: {
    Scatter,
    Clip,
  },
  data() {
    return {
      sr: "",
      mute: false,
      isLoading: false,
    };
  },
  computed: {
    allPublications() {
      return this.$store.state.allPublications;
    },
    allJournalists() {
      return this.$store.state.allJournalists;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    handleVideo(event) {
      const video = document.getElementById("video");
      if (this.mute) {
        video.muted = false;
      } else {
        video.muted = true;
      }
      this.mute = !this.mute;
    },
    scrollToChart() {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: "smooth",
      });
    },
    setBottomObserver() {
      let previousY = 0;
      let previousRatio = 0;
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: d3.range(0, 1, 0.01),
      };
      let scrollEffect = (entries, observer) => {
        entries.forEach((entry) => {
          if (document.querySelector("#desktop-landing .video")) {
            document.querySelector("#desktop-landing .video").style.opacity =
              1 - entry.intersectionRatio;
            document.querySelector("#chart").style.opacity =
              0.8 + entry.intersectionRatio * 2;
            document
              .querySelectorAll("#chart .circles")
              .forEach((c) => (c.style.opacity = entry.intersectionRatio));
            if (entry.isIntersecting)
              document.querySelector("#chart").style.zIndex = 100;
            else document.querySelector("#chart").style.zIndex = 0;
          }
        });
      };
      let target = document.querySelector("#scroll-bottom");
      let observer = new IntersectionObserver(scrollEffect, options);
      observer.observe(target);
    },
    setTitleObserver() {
      let previousY = 0;
      let previousRatio = 0;
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: d3.range(0, 1, 0.01),
      };
      let hideEffect = (entries, observer) => {
        entries.forEach((entry) => {
          if (document.querySelector("#desktop-landing .title-text")) {
            document.querySelector(
              "#desktop-landing .title-text"
            ).style.opacity = 1 - entry.intersectionRatio * 3;
            if (entry.isIntersecting) {
              document.getElementById("menu").classList.remove("unsticky");
              document.getElementById("menu").classList.add("sticky");
            } else {
              document.getElementById("menu").classList.remove("sticky");
              document.getElementById("menu").classList.add("unsticky");
            }
          }
        });
      };
      let target = document.querySelector("#chart");
      let observer = new IntersectionObserver(hideEffect, options);
      observer.observe(target);
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.allJournalists.length === 0) {
      await this.$store.dispatch("getJournalists");
    }
    /*document.querySelector("#chart").scrollIntoView({
      behavior: "smooth",
    });*/

    if (!this.isMobile) {
      document.getElementById("menu").classList.remove("sticky");
      document.getElementById("menu").classList.add("unsticky");
      document.querySelector("#chart").style.opacity = 0.8;

      setTimeout(() => {
        window.location.hash = "#chart";
        this.setBottomObserver();
        this.setTitleObserver();
      }, 50);
    }
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.desktop {
  .footer {
    z-index: 10;
    background-color: #ebebeb;
    p {
      font-size: 14px;
      font-weight: 500;
    }
    .sponsors {
      height: 60px;
      .brown {
        width: 75px;
      }
      .ddld {
        width: 150px;
      }
      .boell {
        width: 190px;
      }
    }
  }
}
#desktop-landing {
  height: 100vh;
  overflow-y: scroll;
  .group {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    max-width: 98%;
    width: 98%;
    z-index: 10;
    max-height: 100%;
    svg {
      position: absolute;
      top: 0;
      z-index: -1;
      width: 30%;
      left: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 97vw;
      height: 100vh;
      object-fit: cover;
    }
    .video {
      max-height: 99%;
      object-fit: cover;
      clip-path: url(#clip);
      transition: all 1.5s linear;
    }
  }
  .title-text {
    z-index: 30;
    position: absolute;
    top: 9%;
    left: 2.5rem;
    transition: opacity 1s ease-in-out;
    h1 {
      font-size: 5rem;
      line-height: 1;
      color: #fff;
      -webkit-text-stroke: 1px #000;
    }
  }
  #scroll-bottom {
    height: 50vh;
    background-color: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: -15;
  }
}
#home {
  .video {
    filter: brightness(0.6);
  }
  #left-menu {
    width: 25%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000000ee;
    p {
      color: white;
      font-size: 11px;
      line-height: 14px;
    }
  }
}

.mobile-home {
  .mobile-landing {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    h1 {
      font-size: 3rem;
      margin-top: 8%;
      line-height: 1;
      color: #fff;
      -webkit-text-stroke: 1px #000;
    }
    p.loading {
      position: absolute;
      bottom: 15px;
      z-index: 5;
      color: #fff;
      left: 40%;
    }
    .intro {
      height: 50%;
      z-index: 10;
      line-height: 1;
    }
    .mask {
      position: absolute;
      z-index: 5;
      width: 110%;
      height: 100%;
      top: 30px;
      object-position: bottom;
      object-fit: cover;
    }
    .mobile-video-group {
      position: absolute;
      bottom: 0;
      height: 50%;
      .video {
        height: 100%;
        width: 100vw;
        object-fit: cover;
      }
      i {
        position: absolute;
        bottom: 12px;
        color: #fff;
        z-index: 100;
        left: 46%;
        font-size: 43px;
      }
    }
  }
  #chart {
    z-index: 100;
    margin-top: 3rem;
  }
}

#desktop-landing .video {
  -webkit-animation: fadein 1.5s;
  -moz-animation: fadein 1.5s; /* Firefox < 16 */
  -ms-animation: fadein 1.5s; /* Internet Explorer */
  -o-animation: fadein 1.5s; /* Opera < 12.1 */
  animation: fadein 1.5s;
  animation-timing-function: ease-in; /* 
  -webkit-animation-delay: 2s;
  animation-delay: 2s; */
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@media (min-width: 550px) and (max-width: 767.99px) {
  .intro {
    height: 40% !important;
  }
  .mobile-landing {
    h1 {
      margin-top: 0px !important;
    }
    p {
      position: absolute;
      top: 75%;
      left: 29%;
    }
    .mask {
      object-fit: initial !important;
    }
  }
}
@media (min-width: 768px) and (max-width: 1169px) {
  .title-text {
    p {
      margin-top: 20% !important;
    }
  }
}
</style>
